import {Popup} from 'extensions/viewport/Popup';
import {useGetNamespaceContext} from 'interface/stacks/workspace/hooks/useGetNamespaceContext';
import {useState} from 'react';
import type {FilesItem} from 'store/slices/files/types';
import {AiChatSearch} from './AiChatSearch';

interface Props {
  trigger: (onPress: () => void) => React.ReactNode;
  fileList: FilesItem[];
  handleAdd: (file: FilesItem) => void;
  handleRemove: (file: FilesItem) => void;
  filterForShowing: (item: FilesItem) => boolean;
  filterForEnabling: (item: FilesItem) => boolean;
  showCurrentFolder?: boolean;
}

export function AiChatSearchPopup({
  trigger,
  fileList,
  handleAdd,
  handleRemove,
  filterForShowing,
  filterForEnabling,
  showCurrentFolder = false,
}: Props) {
  const [hasMenu, setHasMenu] = useState(false);

  const {namespace, instanceId, instanceName, name} = useGetNamespaceContext();

  return (
    <Popup
      triggerElement={trigger(() => setHasMenu(true))}
      isOpen={hasMenu}
      placement="top-start"
      close={() => setHasMenu(false)}>
      {/* TODO: AICHAT: Handle for Shares */}
      <AiChatSearch
        files={fileList}
        onAdd={handleAdd}
        onRemove={handleRemove}
        instanceAlt={instanceName}
        instanceId={instanceName}
        instanceName={name}
        instanceNs={namespace}
        filterForShowing={filterForShowing}
        filterForEnabling={filterForEnabling}
        showCurrentFolder={showCurrentFolder}
      />
    </Popup>
  );
}
